// @ts-nocheck
/* eslint-disable */
export default class Melown3dCompass {
	/**
	 * Kompas ala fallout.
	 *
	 * @param {Function} [cb] Callback kliknuti na kompas
	 * @param {Object} [scope] Scope
	 *
	 */
	constructor(cb, scope, trans) {
		this._cb = cb;
		this._scope = scope;
		this._trans = trans;
		this._rootEl = null;
	}

	/**
	 * Odstraneni kompasu.
	 */
	destroy() {
		if (this._rootEl) {
			this._rootEl.remove();
		}

		this._cb = null;
	}

	/**
	 * Ziskani DOM containeru.
	 *
	 * @return {Element}
	 */
	getContainer() {
		return this._rootEl;
	}

	/**
	 * Zmena uhlu yaw - 0 sever, + SV, - SV, 0-360
	 *
	 * @param  {Number} yaw Uhel otoceni
	 */
	setYaw(yaw) {
	}

	/**
	 * Spusteni callback funkce.
	 */
	_runCb() {
		if (typeof this._cb === "function") {
			this._cb.apply(this._scope || this, []);
		}
	}
}
